import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import useSystemAlert from '@/hooks/useSystemAlert';
import { notificationApi } from '@/notifications/services/notificationsApi';
import { ROUTE_NAMES } from '@/core/routes/routeNames';

function NotificationAlertHandler() {
  const [getNotificationMessage, { data: notificationData, isSuccess: isNotificationSuccess }] =
    notificationApi.useGetNotificationMessageMutation();

  const location = useLocation();

  useEffect(() => {
    void getNotificationMessage();
  }, [location.pathname === `/${ROUTE_NAMES.DASHBOARD.DASHBOARD}`]);

  useSystemAlert({
    condition: () =>
      isNotificationSuccess && (notificationData ? notificationData.data.isActive : false),
    dependencies: [isNotificationSuccess, notificationData?.data],
    description: notificationData?.data.message ? notificationData?.data.message : '',
  });

  return null;
}

export default NotificationAlertHandler;
